export const ANIMATION_TIMEOUTS = {
  COLLAPSE: 600,
};
